import { chooseAthlete } from '../api/coach-booking.js';

/** "Athlete · Noa Park", and Change - on the calendar and on the hour. */
export function ChosenAthlete({ name }: { name: string }) {
  return (
    <div className="fact chosen-athlete">
      <span className="label">Athlete</span>
      <span className="value">{name}</span>
      <button type="button" className="change" onClick={() => chooseAthlete(null)}>
        Change
      </button>
    </div>
  );
}
